import { connect } from 'react-redux';
import NavCollapse from '../components/blocks/navigation/NavCollapse';
import { openModal } from '../redux/actions/modal';
import { CHECKIN_MODAL } from '../redux/reducers/modal';
import type { State } from '../types';

const mapStateToProps = (state: State) => ({
  currentUser: state.currentUser,
});

const mapDispatchToProps = (dispatch: any) => ({
  onOpenCheckinModal: () => {
    dispatch(openModal({ id: CHECKIN_MODAL, display: true, disableButtons: false }));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(NavCollapse);
